import classnames from "classnames";
import PropTypes from "prop-types";

import "./label.scss";

const Label = ({
  htmlFor,
  text,
  className,
  required,
  showRequiredAsterisk,
  showRequiredLabel,
  children,
  ...restProps
}) => {
  const isRequired = typeof required === "string" ? !!required : required;

  return (
    <label
      htmlFor={htmlFor}
      className={classnames("form-label", className)}
      {...restProps}
    >
      <span>
        {text || children}
        {showRequiredAsterisk && (
          <span className="form-label__asterisk" aria-hidden="true">
            *
          </span>
        )}
      </span>
      {isRequired && showRequiredLabel && (
        <span className="form-label__required" aria-hidden="true">
          required
        </span>
      )}
    </label>
  );
};

Label.propTypes = {
  htmlFor: PropTypes.string.isRequired,
  text: PropTypes.string,
  className: PropTypes.string,
  required: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  showRequiredAsterisk: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  showRequiredLabel: PropTypes.bool,
  children: PropTypes.node,
};

export default Label;
